import { takeLatest, call, select } from 'redux-saga/effects';
import { setDefaultPayment, setDefaultAddress } from 'yoda-interfaces/lib/Account/AccountApi';
import get from 'lodash/get';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import * as actionTypes from '../actionTypes/ExpressCheckoutActionTypes';

function* updatePayment() {
    try {
        const orderPaymentInfo = (state) => state.orderPaymentInfo;
        const orderPaymentInfoDetails = yield select(orderPaymentInfo);
        const paymentId = orderPaymentInfoDetails && orderPaymentInfoDetails[0].relationshipId;
        const paymentParams = {
            payload: {
                id: paymentId,
                requestBody: [
                    {
                        op: 'replace',
                        path: '/expressCheckout',
                        value: 'true',
                    },
                ],
            },
        };
        yield call(FactorySaga, setDefaultPayment, paymentParams);
    } catch (error) {
        console.error('Error in getting the content for update payment');
    }
}

function* updateAddress() {
    try {
        const orderShippingGroupsInfo = (state) => state.orderShippingGroupsInfo;
        const orderShippingGroupsInfoDetails = yield select(orderShippingGroupsInfo);
        const id = get(
            orderShippingGroupsInfoDetails[0],
            'address.relationships.accountAddress.id'
        );
        const addressParams = {
            payload: {
                id,
                requestBody: [
                    {
                        op: 'replace',
                        path: '/expressCheckout',
                        value: 'true',
                    },
                ],
            },
        };
        yield call(FactorySaga, setDefaultAddress, addressParams);
    } catch (error) {
        console.error('Error in getting the content for update payment');
    }
}

const watchExpressCheckoutSaga = function* watchExpressCheckoutSaga() {
    yield takeLatest(actionTypes.EXPRESS_CHECKOUT_PAYMENT, updatePayment);
    yield takeLatest(actionTypes.EXPRESS_CHECKOUT_ADDRESS, updateAddress);
};
watchExpressCheckoutSaga.sagaName = 'watchExpressCheckoutSaga';

export default watchExpressCheckoutSaga;
